import React from "react";
import Modal, { CommonModalProps } from "..";
import useCustomSnackbar from "../../../Utils/Hooks/useCustomSnackbar";
import CommentForm from "../../Misc/CommentForm/comment-form";
import { logService } from "../../../Core/Api/services";
import { ActivityKind } from "../../../Core/Api/Types/activity-kind";
import { useTranslation } from "react-i18next";

export type ModalActivityAddCommentElementProps = {
  objectIds: number[];
  kind: ActivityKind;
};
export type ModalActivityAddCommentProps = CommonModalProps<ModalActivityAddCommentElementProps>;

const ModalActivityAddComment = React.forwardRef<any, ModalActivityAddCommentProps>((props, ref) => {
  const { t } = useTranslation();
  const { objectIds, kind, closeModal } = props;

  const enqueueCustomSnackbar = useCustomSnackbar();

  const handleCancelClick = () => {
    closeModal();
  };

  const handleAddComment = (comment: string) => {
    objectIds.forEach((objectId) => {
      logService
        .InsertActivityComment({
          message: comment,
          resId: objectId,
          kind: kind,
          activityReplyId: null,
        })
        .then(() => {
          enqueueCustomSnackbar(t("alert:error.commentPosted", { kind }), "success");
        });
    });
    closeModal();
  };

  return (
    <Modal title={t("modal:title.newComment")} reference={ref} closeModal={handleCancelClick} width={680}>
      <CommentForm onSend={handleAddComment} sx={{ mt: 2 }} />
    </Modal>
  );
});

export default ModalActivityAddComment;
